import { useContext, useEffect, useState } from "react";
import { VideoContext } from "../../Context/Videos";
import { DiseaseContext } from "../../Context/Disease";
import { EventContext } from "../../Context/Events";
import { fetchEventsAction } from "../../Context/Events/action";
import { fetchVideoAction } from "../../Context/Videos/action";
import VideoCard from "../../Components/VideoPlayer";

import EventCard from "../../Components/Events/EventCardLandScape";
import Button from "../../Components/Buttons";
// import useModal from "../../HOC/useModal";
// import FullScreenPlayer from "../../Components/VideoPlayer/ModalPlayer";
import routes from "../../utils/routes";
import { useHistory, Link } from "react-router-dom";
import { dropRightWhile } from "lodash";

const HomeResources = () => {
  const { push } = useHistory();

  const pushToResourcesPage = (e) => {
    e.preventDefault();
    push(routes?.resources);
  };

  const { videosState, dispatch: videoDispatch } = useContext(VideoContext);
  const {
    diseaseState: { activeDisease },
  } = useContext(DiseaseContext);

  const {
    eventState: {
      events: { data = [] },
    },
    dispatch: eventDispatch,
  } = useContext(EventContext);


  useEffect(() => {
    eventDispatch(
      fetchEventsAction({
        disease: activeDisease?.disease_id,
        page: 1,
      })
    );
  }, [eventDispatch, activeDisease]);

  useEffect(() => {
    videoDispatch(
      fetchVideoAction({
        disease: activeDisease?.disease_id,
        page: 1,
        count: 1,
      })
    );
  }, [videoDispatch, activeDisease]);

  // const { modal, openModal, closeModal } = useModal();

  // const playVideoHandler = (video) => {
  //   openModal(<FullScreenPlayer onCancel={closeModal} video={video} />);
  // };

  const [isPlaying, setIsPlaying] = useState(false);


  const playVideoHandler = (video) => {
      setIsPlaying(true)
  }; 

  const onStopHandler = () => {
    setIsPlaying(false)
  }

  console.log(data, 'this is the data')

  return (
    <>
      {/* {modal} */}
      <div>
        <div className="layout__wrapper py-6 md:py-72 font-poppins lg:flex lg:flex-row-reverse lg:items-center lg:py-104">
          <div className="h-167 md:h-409 lg:w-2cols lg:ml-9 lg:flex-shrink-0">
            <VideoCard
              video={videosState?.videos?.data?.[0]}
              playVideoHandler={playVideoHandler}
              variant="dark"
              isPlaying={isPlaying}
              stopVideoHandler={onStopHandler}
            />
          </div>
          <div className="pt-6 lg:pt-0 lg:w-2cols">
            <h6 className="font-bold leading-48 text-chestNut text-28px md:text-38 md:mb-3">
              Resources
            </h6>
            <p className="text-xs leading-6 font-normal text-metal md:text-base lg:text-justify">
              The Resources expended during the pandemic ranged from grants,
              donations, loans and material support. The CTAP project looks to
              track all the resources committed to Africa. As we believe this
              will give us a perspective as towards the management of COVID-19
              funds in Africa.
            </p>
            <div className="pt-8 lg:w-3/4">
              {dropRightWhile([...data], (_, index) => index > 1)?.map(
                (event) => (
                  <div key={event?.id} className="h-24 mb-4 last:mb-0 md:h-122">
                    <Link to={`${routes.event}/${event?.slug}`}>
                      <EventCard event={event} />
                    </Link>
                  </div>
                )
              )}
            </div>
            <div className="pt-6 lg:w-3/4">
              <Button onClick={pushToResourcesPage} type="button">
                <span className="inline-block py-4 text-center w-full font-medium leading-6 text-base">
                  <span>View Resources</span>
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeResources;
